import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { api } from "@/lib/api";
import { playAlert } from "@/lib/sound";

export const useChatAlerts = () => {
  const [alerts, setAlerts] = useState({ unattended: 0, transferred_to_me: 0 });
  const prev = useRef(null);
  const load = () => api.get("/chats-alerts").then(({ data }) => {
    if (prev.current && data.unattended > prev.current.unattended) playAlert();
    prev.current = data;
    setAlerts(data);
  }).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  return [alerts, load];
};

export const AlertBadges = ({ alerts }) => (
  <span className="ml-auto flex items-center gap-1">
    {alerts.waiting > 0 && (
      <span className="min-w-5 h-5 px-1 rounded-full bg-orange-500 text-white text-[10px] font-bold flex items-center justify-center animate-pulse"
            title="Contatos aguardando resposta" data-testid="nav-waiting-badge">{alerts.waiting}</span>
    )}
    {alerts.transferred_to_me > 0 && (
      <span className="min-w-5 h-5 px-1 rounded-full bg-amber-500 text-white text-[10px] font-bold flex items-center justify-center animate-pulse"
            title="Transferidos para você" data-testid="nav-transfer-badge">{alerts.transferred_to_me}</span>
    )}
    {alerts.unattended > 0 && (
      <span className="min-w-5 h-5 px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold flex items-center justify-center animate-pulse"
            title="Contatos sem atendimento" data-testid="nav-unattended-badge">{alerts.unattended}</span>
    )}
  </span>
);

export const NavItems = ({ items, alerts, onNavigate }) => items.map(({ to, label, icon: Icon, testid }) => (
  <NavLink
    key={to} to={to} data-testid={testid} onClick={onNavigate}
    className={({ isActive }) =>
      `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
        isActive ? "bg-emerald-50 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-200" : "text-muted-foreground hover:bg-muted hover:text-foreground"
      }`}
  >
    <Icon className="w-4 h-4" />
    {label}
    {to === "/inbox" && <AlertBadges alerts={alerts} />}
  </NavLink>
));
